package cash.z.ecc.android.crypto

internal actual class SecretKeyCommon(actual val encoded: ByteArray)
